var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"note_icon",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("?")])
}
var staticRenderFns = []

export { render, staticRenderFns }